exports = module.exports = require("../../../../../../../../../../../L180/prototypes/uni-uswebapp/node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".my-label-text-size .v-label{font-size:14px!important}", "", {"version":3,"sources":["C:/Users/vijay/AppData/Local/Temp/claude/e765c3a26afc9a32/165e99a4-2433-4693-95f2-2e25055bc364/scratchpad/deploy/us/src/components/PpmPlanner.vue"],"names":[],"mappings":"AACA,6BACE,wBAA2B,CAC5B","file":"PpmPlanner.vue","sourcesContent":["\n.my-label-text-size .v-label {\n  font-size: 14px !important;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// C:/Users/vijay/L180/prototypes/uni-uswebapp/~/css-loader?{"minimize":true,"sourceMap":true}!C:/Users/vijay/L180/prototypes/uni-uswebapp/~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c7b10260","scoped":false,"hasInlineConfig":false}!C:/Users/vijay/L180/prototypes/uni-uswebapp/~/vue-loader/lib/selector.js?type=styles&index=1!./src/components/PpmPlanner.vue
// module id = 824
// module chunks = 1